import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { fetchAdminFinanceDashboard } from "./thunks";

interface AdminFinanceDashboardState {
  data: any | null;
  loading: boolean;
  error: string | null;
}

const initialState: AdminFinanceDashboardState = {
  data: null,
  loading: false,
  error: null,
};

const adminFinanceDashboardSlice = createSlice({
  name: "adminFinanceDashboard",
  initialState,
  reducers: {
    clearAdminFinanceDashboard: (state) => {
      state.data = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAdminFinanceDashboard.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(
        fetchAdminFinanceDashboard.fulfilled,
        (state, action: PayloadAction<any>) => {
          state.loading = false;
          state.data = action.payload;
        },
      )
      .addCase(fetchAdminFinanceDashboard.rejected, (state, action) => {
        state.loading = false;
        state.error =
          (action.payload as { error: string })?.error || "Erro desconhecido";
      });
  },
});

export const { clearAdminFinanceDashboard } =
  adminFinanceDashboardSlice.actions;
export default adminFinanceDashboardSlice.reducer;
